// Validação centralizada de variáveis de ambiente
// Exibe aviso claro quando chaves necessárias estão ausentes ou inválidas.

import { toastWarning } from './toast';

/**
 * Lista de variáveis obrigatórias para funcionamento estável do app.
 * Não inclui valores, apenas verifica presença e formato básico.
 */
const REQUIRED_ENV_KEYS = [
  'VITE_API_BASE_URL',
  'VITE_AUTH_SEED',
  'VITE_PERMITE_PARCELAMENTO_CARTAO'
];

/**
 * Lista de chaves opcionais recomendadas para melhor experiência.
 */
export const OPTIONAL_ENV_KEYS = [
  'VITE_MAX_PARCELAS',
  'VITE_TAXA_CARTAO_PERCENTUAL',
  'VITE_TAXA_CARTAO_POR_PARCELA',
  'VITE_ENABLE_NETWORK_LOGS',
  'VITE_ENABLE_GTM',
  'VITE_ENV'
];

/**
 * Faz uma validação básica das variáveis de ambiente e emite um toast de aviso
 * se algo obrigatório estiver faltando ou claramente inválido.
 */
export function validateAndWarnEnv() {
  const missingRequired: string[] = [];
  const invalidValues: string[] = [];

  REQUIRED_ENV_KEYS.forEach(key => {
    const envMap = import.meta.env as Record<string, string | boolean | undefined>;
    const val = envMap[key];
    if (val === undefined || val === '' || val === null) {
      missingRequired.push(key);
    }
  });

  // Validações simples de formato/semântica
  const permiteParcelamento = import.meta.env.VITE_PERMITE_PARCELAMENTO_CARTAO;
  if (permiteParcelamento !== 'true' && permiteParcelamento !== 'false') {
    invalidValues.push('VITE_PERMITE_PARCELAMENTO_CARTAO (use "true" ou "false")');
  }

  // Validação da flag que desativa o step de pagamento em convite
  const disableInvitePayment = (import.meta.env as Record<string, string | boolean | undefined>).VITE_DISABLE_INVITE_PAYMENT_STEP;
  if (disableInvitePayment && disableInvitePayment !== 'true' && disableInvitePayment !== 'false') {
    invalidValues.push('VITE_DISABLE_INVITE_PAYMENT_STEP (use "true" ou "false")');
  }

  // {|INICIO| 09/04/2026 às 12:15 - INTEGRAÇÃO GTM: VALIDAÇÃO DA FLAG VITE_ENABLE_GTM}
  const enableGtm = (import.meta.env as Record<string, string | boolean | undefined>).VITE_ENABLE_GTM;
  if (enableGtm && enableGtm !== 'true' && enableGtm !== 'false') {
    invalidValues.push('VITE_ENABLE_GTM (use "true" ou "false")');
  }
  // {|FIM| 09/04/2026 às 12:15 - INTEGRAÇÃO GTM: VALIDAÇÃO DA FLAG VITE_ENABLE_GTM}

  // Exibir aviso consolidado (não bloquear execução)
  if (missingRequired.length > 0 || invalidValues.length > 0) {
    const msgParts: string[] = [];
    if (missingRequired.length > 0) {
      msgParts.push(`Faltando: ${missingRequired.join(', ')}`);
    }
    if (invalidValues.length > 0) {
      msgParts.push(`Inválidas: ${invalidValues.join(', ')}`);
    }
    const message = msgParts.join(' | ');
    toastWarning({
      title: 'Configuração do Ambiente',
      message: message || 'Verifique suas variáveis de ambiente (.env).',
      position: 'topCenter',
      timeout: 7000
    });
  }
}
